// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared admin styles for Roles and Users pages */

.admin-page-container {
  width: 100%;
  min-height: 90vh;
  background: var(--app-bg);
  padding: 32px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: var(--text);
}

.admin-page-content {
  max-width: 1200px;
  margin: 0 auto;
  background: var(--surface);
  border-radius: 12px;
  padding: 32px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border);
}

.admin-page-container .header-section {
  text-align: left;
  margin-bottom: 24px;
}

.admin-page-container .page-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-strong);
  margin-bottom: 8px;
}

.admin-page-container .page-subtitle {
  font-size: 1rem;
  color: var(--text-muted);
  margin: 0;
}

.admin-loading {
  text-align: center;
  color: var(--text-muted);
  padding: 2rem;
}

.admin-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.admin-btn {
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
}

.admin-btn.primary {
  background: var(--primary);
  color: #fff;
}

.admin-btn.primary:hover {
  background: var(--primary-hover);
}

.admin-btn.secondary {
  background: var(--surface-3);
  color: var(--text);
}

.admin-btn.secondary:hover {
  background: var(--border-strong);
}

.admin-btn.link {
  background: none;
  color: var(--primary);
  padding: 4px 12px;
}

.admin-btn.link:hover {
  text-decoration: underline;
}

.admin-btn.link.danger {
  color: var(--danger);
}

.admin-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--border);
  border-radius: 8px;
}

.admin-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  color: var(--text);
}

.admin-table th,
.admin-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid var(--border);
}

.admin-table th {
  background: var(--surface-2);
  color: var(--text-strong);
  font-weight: 600;
}

.admin-table tbody tr:hover {
  background: var(--surface-hover);
}

.admin-th-actions,
.admin-td-actions {
  width: 140px;
  text-align: right;
}

.admin-td-actions {
  white-space: nowrap;
}

.admin-td-actions .admin-btn + .admin-btn {
  margin-left: 8px;
}

.admin-empty {
  color: var(--text-subtle);
  font-style: italic;
  text-align: center;
  padding: 24px !important;
}

/* Modal */
.admin-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.admin-modal {
  background: var(--surface);
  border-radius: 12px;
  padding: 24px;
  max-width: 560px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border);
}

.admin-modal-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-strong);
  margin-bottom: 20px;
  text-align: left;
}

.admin-form-group {
  margin-bottom: 16px;
  text-align: left;
}

.admin-form-group label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 6px;
  text-align: left;
}

.admin-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 14px;
  color: var(--text);
  background: var(--surface);
}

.admin-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-soft);
}

.admin-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
}

@media (max-width: 768px) {
  .admin-page-container {
    padding: 12px;
    min-height: auto;
  }

  .admin-page-content {
    padding: 16px;
    border-radius: 10px;
  }

  .admin-page-container .page-title {
    font-size: 1.375rem;
  }

  .admin-page-container .page-subtitle {
    font-size: 0.875rem;
  }

  .admin-toolbar {
    justify-content: stretch;
  }

  .admin-toolbar .admin-btn {
    width: 100%;
  }

  .admin-table-wrap {
    -webkit-overflow-scrolling: touch;
  }

  .admin-table {
    min-width: 640px;
  }

  .admin-table th,
  .admin-table td {
    padding: 10px 12px;
    font-size: 13px;
  }

  .admin-modal-overlay {
    padding: 0;
    align-items: flex-end;
  }

  .admin-modal {
    max-width: none;
    width: 100%;
    max-height: 92vh;
    max-height: 92dvh;
    border-radius: 16px 16px 0 0;
    padding: 20px 16px max(20px, env(safe-area-inset-bottom));
  }

  .admin-modal-actions {
    flex-direction: column-reverse;
    gap: 8px;
  }

  .admin-modal-actions .admin-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/common.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,uFAAuF;EACvF,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;IAC5B,yDAAyD;EAC3D;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Shared admin styles for Roles and Users pages */\n\n.admin-page-container {\n  width: 100%;\n  min-height: 90vh;\n  background: var(--app-bg);\n  padding: 32px;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  color: var(--text);\n}\n\n.admin-page-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  background: var(--surface);\n  border-radius: 12px;\n  padding: 32px;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border);\n}\n\n.admin-page-container .header-section {\n  text-align: left;\n  margin-bottom: 24px;\n}\n\n.admin-page-container .page-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-strong);\n  margin-bottom: 8px;\n}\n\n.admin-page-container .page-subtitle {\n  font-size: 1rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n.admin-loading {\n  text-align: center;\n  color: var(--text-muted);\n  padding: 2rem;\n}\n\n.admin-toolbar {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.admin-btn {\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s ease;\n}\n\n.admin-btn.primary {\n  background: var(--primary);\n  color: #fff;\n}\n\n.admin-btn.primary:hover {\n  background: var(--primary-hover);\n}\n\n.admin-btn.secondary {\n  background: var(--surface-3);\n  color: var(--text);\n}\n\n.admin-btn.secondary:hover {\n  background: var(--border-strong);\n}\n\n.admin-btn.link {\n  background: none;\n  color: var(--primary);\n  padding: 4px 12px;\n}\n\n.admin-btn.link:hover {\n  text-decoration: underline;\n}\n\n.admin-btn.link.danger {\n  color: var(--danger);\n}\n\n.admin-table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n}\n\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  color: var(--text);\n}\n\n.admin-table th,\n.admin-table td {\n  padding: 12px 16px;\n  text-align: left;\n  border-bottom: 1px solid var(--border);\n}\n\n.admin-table th {\n  background: var(--surface-2);\n  color: var(--text-strong);\n  font-weight: 600;\n}\n\n.admin-table tbody tr:hover {\n  background: var(--surface-hover);\n}\n\n.admin-th-actions,\n.admin-td-actions {\n  width: 140px;\n  text-align: right;\n}\n\n.admin-td-actions {\n  white-space: nowrap;\n}\n\n.admin-td-actions .admin-btn + .admin-btn {\n  margin-left: 8px;\n}\n\n.admin-empty {\n  color: var(--text-subtle);\n  font-style: italic;\n  text-align: center;\n  padding: 24px !important;\n}\n\n/* Modal */\n.admin-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: var(--overlay);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.admin-modal {\n  background: var(--surface);\n  border-radius: 12px;\n  padding: 24px;\n  max-width: 560px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--border);\n}\n\n.admin-modal-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-strong);\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.admin-form-group {\n  margin-bottom: 16px;\n  text-align: left;\n}\n\n.admin-form-group label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text);\n  margin-bottom: 6px;\n  text-align: left;\n}\n\n.admin-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  font-size: 14px;\n  color: var(--text);\n  background: var(--surface);\n}\n\n.admin-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-soft);\n}\n\n.admin-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border);\n}\n\n@media (max-width: 768px) {\n  .admin-page-container {\n    padding: 12px;\n    min-height: auto;\n  }\n\n  .admin-page-content {\n    padding: 16px;\n    border-radius: 10px;\n  }\n\n  .admin-page-container .page-title {\n    font-size: 1.375rem;\n  }\n\n  .admin-page-container .page-subtitle {\n    font-size: 0.875rem;\n  }\n\n  .admin-toolbar {\n    justify-content: stretch;\n  }\n\n  .admin-toolbar .admin-btn {\n    width: 100%;\n  }\n\n  .admin-table-wrap {\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .admin-table {\n    min-width: 640px;\n  }\n\n  .admin-table th,\n  .admin-table td {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n\n  .admin-modal-overlay {\n    padding: 0;\n    align-items: flex-end;\n  }\n\n  .admin-modal {\n    max-width: none;\n    width: 100%;\n    max-height: 92vh;\n    max-height: 92dvh;\n    border-radius: 16px 16px 0 0;\n    padding: 20px 16px max(20px, env(safe-area-inset-bottom));\n  }\n\n  .admin-modal-actions {\n    flex-direction: column-reverse;\n    gap: 8px;\n  }\n\n  .admin-modal-actions .admin-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
